import {
  AbilityBuilder,
  type MongoAbility,
} from '@casl/ability'


// actions
type BaseActions = 'create' | 'read' | 'update' | 'delete' | 'access'
type Aliases = 'crud'
type Actions = BaseActions | Aliases

// subjects
export type Subjects =
  | 'Algorithm'
  | 'Annotation'
  | 'Branding'
  | 'Camera'
  | 'Charts'
  | 'Class'
  | 'ConnectedPlatformDeployment'
  | 'Datapool'
  | 'Dataset'
  | 'Import'
  | 'Inference'
  | 'Job'
  | 'Member'
  | 'Model'
  | 'Project'
  | 'Projects'
  | 'Recording'
  | 'Resource'
  | 'Review'
  | 'Settings'
  | 'Tag'
  | 'Test'
  | 'Workflow'

export type RvaiAbilityTuple = [Actions, Subjects]
export type RvaiAbility = MongoAbility<RvaiAbilityTuple>
export type RvaiAbilityBuilder = AbilityBuilder<RvaiAbility>

// mapping of aliases to actions
export const aliases: Record<Aliases, BaseActions[]> = {
  crud: ['create', 'read', 'update', 'delete'],
}
